'use client';

// Core
import { FC } from 'react';
// Global UI components
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
// Vendors
import { useTranslations } from '@/hooks/useTranslations';
// Local components
import { CreateProductForm } from '../create/create-product-form';
import { useProductContext } from '@/contexts/product-context';

export const CreateProductPopup: FC = () => {
  const { dispatch, state } = useProductContext();

  const t = useTranslations('CreateProductPopup');

  const handleOpenChange = (isOpen: boolean) => {
    if (isOpen) {
      dispatch({ type: 'OPEN_CREATE_PRODUCT_POPUP' });
    } else {
      dispatch({ type: 'CLOSE_CREATE_PRODUCT_POPUP' });
    }
  };

  return (
    <Sheet
      open={state.isCreateProductPopupOpen}
      onOpenChange={handleOpenChange}
    >
      <SheetContent className="bg-white dark:bg-black">
        <SheetHeader>
          <SheetTitle className="text-left">{t('title')}</SheetTitle>
          <SheetDescription>{t('description')}</SheetDescription>
        </SheetHeader>

        <div className="grid gap-4 p-4">
          <CreateProductForm />
        </div>
      </SheetContent>
    </Sheet>
  );
};
